enum SORT_ORDER {
    NONE = '',
    ASCENDING = 'ASC',
    DESCENDING = 'DESC',
}

export default SORT_ORDER
